/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ProductsAboveAveragePriceAddComponent
 * Purpose		: This component retrieves specified record and shows details.
 * Dependency	: ProductsAboveAveragePriceService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';
import { ProductsAboveAveragePriceData, ProductsAboveAveragePriceService }  from './ProductsAboveAveragePrice.service';


@Component({
  template: require('./ProductsAboveAveragePriceDetails.component.html'),
  providers: [ProductsAboveAveragePriceService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class ProductsAboveAveragePriceDetailsComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objProductsAboveAveragePrice: ProductsAboveAveragePriceData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private toastr: ToastsManager,
		private ProductsAboveAveragePriceService: ProductsAboveAveragePriceService

	) {
		// this.id = parseInt(params.get('id'));
		this.objProductsAboveAveragePrice = new ProductsAboveAveragePriceData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.ProductsAboveAveragePriceService.getByID(+params['id']))
		.switchMap((params: Params) => this.ProductsAboveAveragePriceService.getByID(params['id']))
		.subscribe((item: ProductsAboveAveragePriceData) => this.objProductsAboveAveragePrice = item);
		this.getLookups();
	}

	deleteProductsAboveAveragePrice(id: string) {
		if (window.confirm('Are you sure you want to delete this ProductsAboveAveragePrice?') == true) 
		{
			this.ProductsAboveAveragePriceService.deleteProductsAboveAveragePrice(this.objProductsAboveAveragePrice.ProductName.toString())
			.subscribe(record => this.router.navigate(['/ProductsAboveAveragePrice']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { console.log('ProductsAboveAveragePrice record deleted successfully...'); }
			);
		}
	}
	gotoProductsAboveAveragePriceEdit() {
		this.router.navigate(['/ProductsAboveAveragePrice', this.objProductsAboveAveragePrice.ProductName]);
	}

	gotoProductsAboveAveragePrice() {
		this.router.navigate(['/ProductsAboveAveragePrice']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/ProductsAboveAveragePrice/ProductsAboveAveragePriceDetails.component.ts